/* eslint-disable no-use-before-define */

import React from "react";
import { ActivityIndicator, Button, Text, View } from "react-native";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Phone from "../utils/Phone";
import {
  checkWifi,
  failWifi,
  resetConnectionStatus,
  setWired,
} from "../redux/actions/connection";
import MenuButton from "../components/MenuButton";
import { errorColors, RepositColours, RepositStyles } from "../utils/styles";
import WebHeading from "../components/WebHeading";
import Icon from "react-native-vector-icons/FontAwesome";
import goTo from "../utils/goTo";
import storage from "../utils/storage";

const questionCircle = (
  <Icon name="warning" size={100} color={errorColors.orange} />
);

const mapStateToProps = (state) => ({
  box: state.box,
  connection: state.connection,
});

const mapDispatchToProps = (dispatch) => {
  return {
    connectionActions: bindActionCreators(
      { setWired, checkWifi, failWifi, resetConnectionStatus },
      dispatch
    ),
  };
};

const WirelessLoading = ({ status, message, retry }) => {
  return status === "FAILED" || status === "NO_CONTACT" ? (
    <View style={{ flex: 1, justifyContent: "center" }}>
      <View style={{ flex: 4, justifyContent: "center" }}>
        <Text style={{ textAlign: "center" }}>{questionCircle}</Text>
        <Text style={{ ...RepositStyles.paragraphText, marginVertical: 20 }}>
          We were unable to connect to the customer's wired network. You can
          retry by tapping the button below.
        </Text>
      </View>
      <View style={{ flex: 1, justifyContent: "flex-start" }}>
        <Button
          title="Retry Connection"
          onPress={() => retry()}
          color={RepositColours.blue}
        />
      </View>
      <View style={{ flex: 1, justifyContent: "center" }}>
        <Text style={RepositStyles.paragraphText}>
          If the problem persists <Phone>call Reposit on</Phone>
        </Text>
      </View>
    </View>
  ) : (
    <View style={{ flex: 1, backgroundColor: "#3CA5D5" }}>
      <View style={{ flex: 4 }} />
      <View style={{ flex: 1 }}>
        <ActivityIndicator size="large" color="white" />
      </View>
      <View style={{ flex: 6 }}>
        <Text
          style={{
            ...RepositStyles.headerText,
            marginTop: 20,
            marginBottom: 10,
            color: "white",
          }}
        >
          {status === null
            ? null
            : status.charAt(0) + status.slice(1).toLowerCase()}
        </Text>
        <Text
          style={{
            ...RepositStyles.paragraphText,
            textAlign: "center",
            color: "white",
          }}
        >
          {message}
        </Text>
      </View>
    </View>
  );
};

class WiredConnection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      showPassword: true,
    };
  }
  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "New Setup",
  };

  componentDidMount() {
    this.setWired();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.connection.status === "SUCCESS") {
      if (this.props.connection.status !== "SUCCESS") {
        goTo(this.props.navigation, "SoftwareInstallation");
      }
    }
  }

  setWired = () => {
    let serialNum = this.props.box.serialNumber;
    if (!serialNum) {
      storage
        .load({ key: "serialNum" })
        .then((ret) => {
          this.props.connectionActions.setWired(ret);
        })
        .catch((err) => {
          console.log(err);
          this.props.connectionActions.setWired(this.props.box.serialNumber);
        });
    } else {
      console.log("FOUND SERIAL NUMBER");
      this.props.connectionActions.setWired(this.props.box.serialNumber);
    }

    setTimeout(this.checkWifi, 15000);
  };

  checkWifi = () => {
    if (
      this.props.connection.status !== "SUCCESS" &&
      this.props.connection.status !== "FAILED" &&
      this.props.connection.status !== "NO_CONTACT" &&
      this.props.connection.status !== null
    ) {
      let serialNum = this.props.box.serialNumber;
      if (!serialNum) {
        storage
          .load({ key: "serialNum" })
          .then((ret) => {
            this.props.connectionActions.checkWifi(ret);
          })
          .catch((err) => {
            console.log(err);
            this.props.connectionActions.checkWifi(this.props.box.serialNumber);
          });
      } else {
        this.props.connectionActions.checkWifi(this.props.box.serialNumber);
      }
      setTimeout(this.checkWifi, 15000);
    }
  };

  render() {
    return (
      <View style={RepositStyles.wrapper}>
        <WebHeading title="New Setup" />
        <View style={RepositStyles.wrapper}>
          <WirelessLoading
            status={this.props.connection.status}
            message={this.props.connection.message}
            retry={this.setWired}
          />
        </View>
      </View>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WiredConnection);



// WEBPACK FOOTER //
// ./src/containers/WiredConnection.js